import React, { useEffect, useState, useRef } from 'react';

import { Flexbox } from '@schoolinks/ui-components';

import * as CredentialHandlerPolyfill from 'credential-handler-polyfill';
import Grid from 'components/Common/Grid';

import CredentialsGrid from 'modules/CredentialWallet/components/CredentialsGrid';
import ListPageHeader from 'modules/CredentialWallet/components/ListPageHeader';
import OverviewCard from 'modules/CredentialWallet/components/OverviewCard';

import s from './CredentialsListPage.css';

const CredentialsListPage = () => {
  const [headerHeight, setHeaderHeight] = useState();
  const headerRef = useRef();

  useEffect(() => {
    CredentialHandlerPolyfill.loadOnce();
  }, []);

  useEffect(() => {
    setHeaderHeight(headerRef?.current?.offsetHeight);
  }, [headerRef]);

  useEffect(() => {
    const handleResize = () => {
      setHeaderHeight(headerRef?.current?.offsetHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Flexbox flexDirection="column">
        <Flexbox
          className={s.header}
          flexDirection="column"
          px={2}
          py={1.5}
          ref={headerRef}
          rowGap={1}
        >
          <ListPageHeader />
        </Flexbox>
      </Flexbox>
      <Flexbox
        className={s.content}
        style={{
          height: `calc(100vh - 64px - ${headerHeight || 0}px)`,
        }}
        width="100%"
      >
        <Grid container width="100%" p={3} columnSpacing={3} rowSpacing={3}>
          <Grid item desktop={4} mobile={12}>
            <OverviewCard />
          </Grid>
          <Grid item desktop={8} mobile={12}>
            <CredentialsGrid />
          </Grid>
        </Grid>
      </Flexbox>
    </>
  );
};

export default CredentialsListPage;
